import { Card, Checkbox, Divider, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import NoteShareModal from "./NoteShare.modal";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import TaskIcon from '@mui/icons-material/Task';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';

const NoteImg = require('./../../assets/fileIcons/note.png');

import AddEditNoteModal from "./AddEditNote.modal";
import NoteInfoModal from "./NoteInfo.modal";
import Swal from "sweetalert2";
import { deleteFile, duplicateFile } from "src/services/file.service";
import FileAuditLogModal from "../file-audit-log/FileAuditLog.modal";
import { formatDate } from "src/methods/common.methods";
import constants from "../constants/common";
import containerMethods from "src/methods/container.methods";

const flags = constants.flags;

class NoteCard extends React.Component {


	constructor(props) {
		super(props);
		this.state = {
			file: null,
			viewNoteModal: false,
			noteInfoModal: false
		}
	}

	noteInfo = async (file) => {
		if (!file) {
            return;
        }
        this.setState({ file: file, noteInfoModal: true });
	}

	viewNote = async (file) => {
        if (!file) {
            return;
        }
		this.setState({ file: file, viewNoteModal: true });
	}

	handleDelete = async (file) => {
		if (!file) {
			return;
		}

		// confirm swal
		let c = await Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#aaa',
			confirmButtonText: 'Yes, delete it!'
		});

		if (c.isConfirmed) {
			// Call the delete API or perform delete action
			let response = await deleteFile(file._id);
			// Handle response
			if (response.error) {
				Swal.fire({
					title: 'Error!',
					text: response.error,
					icon: 'error',
					confirmButtonText: 'Ok'
				});
				return;
			}
			this?.props?.onReload();
			Swal.fire({
				title: 'Deleted!',
				text: 'Your note has been deleted.',
				icon: 'success',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true
			});
		}
	}

	handleDuplicate = async (file) => {
		if (!file) {
			return;
		}

		let response = await duplicateFile(file._id);
		if (response.error) {
			Swal.fire({
				title: 'Error!',
				text: response.error,
				icon: 'error',
				confirmButtonText: 'Ok'
			});
			return;
		}
		this?.props?.onReload();
		Swal.fire({
			title: 'Duplicated!',
			text: 'Your note has been duplicated.',
			icon: 'success',
			showConfirmButton: false,
			timer: 2000,
			timerProgressBar: true
		});
	}

	menu = () => {
		return (
			<Menu
				id="simple-menu"
				anchorEl={this.state.anchorEl}
				open={Boolean(this.state.anchorEl)}
				onClose={() => this.setState({anchorEl: null})}
				anchorReference="anchorPosition"
				anchorPosition={{ top: this.state.clickY, left: this.state.clickX }}
			>
				<MenuItem
					onClick={() => {
						this.handleDuplicate(this.props.file)
						this.setState({anchorEl: null})
					}}
				>
					<ListItemIcon>
						<ContentCopyIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText color="error">
						Duplicate
					</ListItemText>
				</MenuItem>
				<FileAuditLogModal
					file={this.props.file}
					onClose={() => this.setState({anchorEl: null})}
				/>
				{/* If file owner, then show share */}
				{(this.props?.file?.is_owner) ? (
					<NoteShareModal
						file={this.props.file}
						onClose={() => this.setState({anchorEl: null})}
					/>
				) : null}
				<MenuItem onClick={() => {
					this.setState({anchorEl: null})
					this.props?.onSelect(this.props.file);
				}}>
					<ListItemIcon>
						<TaskIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>
						{(this.props?.selected) ? 'Unselect' : 'Select'}
					</ListItemText>
				</MenuItem>
				<Divider />
				<MenuItem color="error"
					onClick={() => {
						this.handleDelete(this.props.file)
						this.setState({anchorEl: null})
					}}
				>
					<ListItemIcon>
						<DeleteForeverIcon fontSize="small" color="error" />
					</ListItemIcon>
					<ListItemText color="error">
						Delete
					</ListItemText>
				</MenuItem>
			</Menu>
		)
	}
	
	cardHeaderTitle = (file) => {
		let show_selection = this.props?.showSelection;
		const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
		return (
			<Tooltip title={file?.name}>
				{(show_selection) ? (
					<Checkbox
						checked={this.props?.selected}
						onChange={() => this.props?.onSelect(file)}
					/>
				) : null}
				{nameWithoutExt}
			</Tooltip>
		)
	}

	render() {

		let file = this.props.file;

		return (
			<>
			<Card variant="outlined"
				sx={{
					display: 'flex', flexDirection: 'column', padding: '8px', borderWidth: 3, borderColor:"divider"
				}}
				onContextMenu={(e) => {
					e.preventDefault();
					this.setState({
						anchorEl: e.currentTarget,
						clickX: e.clientX,
						clickY: e.clientY
					});
				}}
				onDoubleClick={() => this.viewNote(file)}
			>
				{this.menu()}
				<Grid flex={1} flexDirection={'row'} justifyContent={'space-between'} display={'flex'} alignItems={"center"}>
					<img src={NoteImg} style={{height: '16px', width:"16px", marginRight:"8px",borderRadius:"6px", opacity:0.5}} />
					<Typography
						variant="body1"
						color="textPrimary" 
						noWrap
						sx={styles?.fileNameStyles}
					>
						{this.cardHeaderTitle(file)}
					</Typography>
					<Stack direction="row" spacing={1}>
						<Typography variant="caption" color="textSecondary" component="div" sx={{display: 'flex', alignItems: 'center'}}>
							{(file.flags && file.flags.length > 0) ? file.flags.map((flag, idx) => {

								let flag_data = flags.find(f => f.value == flag);
								if (flag_data?.icon) {
									return (
										flag_data.icon
									)
								}

								return null;
							}) : null}
						</Typography>
						{(file?.is_shared_outside_company) ? (
							<Tooltip title="Shared outside company">
								<PeopleOutlinedIcon fontSize="small" style={{ color: 'lightgray' }} />
							</Tooltip>
						) : null}
					</Stack>
				</Grid>
				<Grid sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end'}}>
					<Typography variant="caption" color="text.disabled" component="div" style={{ fontSize: 13 }}>
						{formatDate(file?.updated_at)}
					</Typography>

					<Stack direction="row" spacing={1}>
						<IconButton
							onClick={(e) => {
							e.preventDefault();
							this.setState({
								anchorEl: e.currentTarget,
								clickX: e.clientX,
								clickY: e.clientY,
							});
							}}
							sx={{ p: 0 }}
						>
							<MoreHorizOutlinedIcon />
						</IconButton>
					</Stack>
				</Grid>
				<Stack direction="row">
					{(!file?.is_owner) ? (
						<Stack direction="row" alignItems="center" sx={{ opacity: 0.3, minWidth: 0, flex: 1, flexGrow: 1 }}>
							<ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3 }} />
							<Typography
								variant="body2"
								color="textSecondary"
								component="div"
								noWrap
								sx={{
									fontSize: 13,
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									minWidth: 0,
								}}
							>
								{file?.owner?.name ? (file?.owner?.name + ' (' + file?.owner?.username + ')') : file?.owner?.username}
							</Typography>
						</Stack>
					) : (
						<Stack direction="row" alignItems="center" sx={{ opacity: 0.3, minWidth: 0, flex: 1, flexGrow: 1 }}>
							<ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3 }} />
							<Typography
								variant="body2"
								color="textSecondary"
								component="div"
								noWrap
								sx={{
									fontSize: 13,
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									minWidth: 0,
								}}
							>
								{'You'}
							</Typography>
						</Stack>
					)}
					

					{(file?.containers?.[0]?.name) ? (
						<Stack direction="row" alignItems="center" sx={{ opacity: 0.7, minWidth: 0, flexGrow: 0, flexShrink: 0, maxWidth: 150 }}>
							{containerMethods.getContainerIcon({}, { color: 'gray', fontSize: '15px' })}
							<Typography
								variant="body2"
								color="textSecondary"
								component="div"
								noWrap
								sx={{
									fontSize: 13,
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									minWidth: 0,
								}}
							>
								{file?.containers?.[0]?.name}
							</Typography>
						</Stack>
					) : null}

					<Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ opacity: 0.7, flexShrink: 0 }}>
						<IconButton
							onClick={() => this.noteInfo(file)}
							sx={{ p: 0 }}
						>
							<KeyboardArrowDownIcon />
						</IconButton>
					</Stack>
				</Stack>
			</Card>
			{(this.state.viewNoteModal) ? (
				<AddEditNoteModal
                    hideAddButton={true}
                    file={file}
                    open={this.state.viewNoteModal}
                    onClose={() => this.setState({viewNoteModal: false})}
					onReload={this?.props?.onReload}
				/>
			) : null}
			{(this.state.noteInfoModal) ? (
				<NoteInfoModal
                    hideAddButton={true}
                    file={file}
                    open={this.state.noteInfoModal}
                    onClose={() => this.setState({noteInfoModal: false})}
					onReload={this?.props?.onReload}
				/>
			) : null}
			</>
		)
	}
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <NoteCard {...props} navigate={navigate} params={params} />;
}

const styles={
	fileNameStyles:{
		flex: 1,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
}